/**
 * Public URL for deep-linking to a specific menu item (homepage featured/popular cards).
 *
 * Items WITH a real database id → /product/:id  (full product detail page)
 * Items WITHOUT an id (fallback static placeholders) → /menu  (full menu)
 */
export function menuPathForMenuItemId(id?: string | null): string {
  if (!id || !String(id).trim()) return '/menu';
  return `/product/${encodeURIComponent(String(id).trim())}`;
}

/** DOM id for scrolling/highlighting a menu item card on the Menu page. */
export function menuItemElementId(menuItemId: string): string {
  return `menu-item-${menuItemId}`;
}
